jQuery(document).ready(function($) {
    
    const navItemClasses = ['.tms-header .wp-block-navigation-item a', '.tms-footer .wp-block-navigation-item a']

    function setActiveNavItem(classes) {
        classes.forEach(className => {
            let currentUrl = window.location.href;
            $(className).each(function() {
                if (this.href === currentUrl) {
                    $(this).parent().addClass('active');
                }
            });
        });
    }

    setActiveNavItem(navItemClasses);

    $('#loader').show();

    $(window).on("load", function() {
        $('.tms-gallery').masonry({
            itemSelector: '.wp-block-image',
            percentPosition: false,
            columnWidth: '.wp-block-image',
            gutter: 24
        }).imagesLoaded().always(function() {
            $('#loader').hide();
            $('.tms-gallery').css('visibility', 'visible');
        });
    });
});